var o = /* @__PURE__ */ ((e) => (e.OLD_PRO = "old-pro-theme", e.EFFY = "effy-theme", e.QE = "quelleenergie-theme", e.LPE = "laprimeenergie-theme", e.CALCULEO = "calculeo-theme", e.PRO = "pro-theme", e))(o || {});
function r(e) {
  Object.values(o).filter((t) => t !== e).forEach((t) => document.body.classList.remove(t)), document.body.classList.add(e);
}
export {
  o as Theme,
  r as setTheme
};
